import type { FunctionComponent } from 'react'

import { PrimaryButton, trackingService } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import type { ClientInputs } from '../../../types'

import { budgetApiClient } from '../../../api/budgetApiClient'
import { goToFlow } from '../../../store/actions/flowEntryStatemachineActions'
import { StyledRegularButtonWrapper } from '../GenericLandingPageStyledComponent'

export const AloneSameDeviceStart: FunctionComponent<{
	children?: never
	clientInputs?: ClientInputs
}> = ({ clientInputs }) => {
	const dispatch = useDispatch()
	const { t } = useTranslation()

	return (
		<StyledRegularButtonWrapper>
			<PrimaryButton
				onClick={async () => {
					const response = await budgetApiClient.createCaseWithSubdomainInfo(
						false,
						false,
						clientInputs,
					)
					const applicantId = response?.mainApplicantId
					if (applicantId != null) {
						trackingService.trackEvent('Finished genericLandingPage', {
							applicantId,
						})
						dispatch(goToFlow(applicantId))
					}
				}}
			>
				{t('generic-landing-page-start-btn')}
			</PrimaryButton>
		</StyledRegularButtonWrapper>
	)
}
